/**
 * BLOCK: How-To Schema
 */

import WPSPBlockIcons from '@Controls/block-icons';
import attributes from './attributes';
import edit from './edit';
import save from './save';
import './style.scss';
import deprecated from './deprecated';
import { __ } from '@wordpress/i18n';
import { registerBlockType } from '@wordpress/blocks';

registerBlockType('wpsp/how-to', {
	title: wpsp_blocks_info.blocks['wpsp/how-to'].title,
	description: wpsp_blocks_info.blocks['wpsp/how-to'].description,
	icon: WPSPBlockIcons.how_to,
	category: wpsp_blocks_info.category,
	keywords: [__('how to'), __('schema'), __('wpsp')],
	supports: {
		anchor: true,
	},
	example: {
		innerBlocks: [
			{
				name: 'wpsp/how-to-child',
				attributes: {
					howtoChildTitle: 'Enter a step title',
					iconimgPosition: 'left',
					source_type: 'image',
					seperatorStyle: 'none',
					ctaType: 'all',
					headingTag: 'h4',
				},
			},
			{
				name: 'wpsp/how-to-child',
				attributes: {
					howtoChildTitle: 'Enter a step title',
					iconimgPosition: 'left',
					source_type: 'image',
					seperatorStyle: 'none',
					ctaType: 'all',
					headingTag: 'h4',
				},
			},
		],
	},
	attributes,
	deprecated,
	edit,
	save,
});
